import { LitElement, html, css, type TemplateResult } from "lit";
import { customElement, property } from "lit/decorators.js";
import { localized } from "@lit/localize";

import "@wh-web-front-end/wh-component-library/dist/elements/wh-icon";

declare global {
  interface HTMLElementTagNameMap {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    "web-kiosk-device-attribute": WebKioskDeviceAttributeElement;
  }
}

@localized()
@customElement("web-kiosk-device-attribute")
export class WebKioskDeviceAttributeElement extends LitElement {
  @property({ type: String }) heading = "";

  @property({ type: String }) body = "";

  render(): TemplateResult {
    return html`<section id="device-attribute">
      <slot name="icon"></slot>
      <div id="text-content">
        <h1>${this.heading}</h1>
        <p>${this.body}</p>
      </div>
    </section>`;
  }

  static styles = css`
    :host {
      --web-kiosk-bg-blue: #c1e8ff;
      --web-kiosk-bg-grey: #f5f5f0;
      --web-kiosk-link-color: #284b9b;
      --web-kiosk-text-color: #323264;
      --web-kiosk-device-attribute-body-color: black;
      --web-kiosk-panel-padding-m: 64px;
      --web-kiosk-panel-padding-sm: 56px;
    }

    #device-attribute {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-direction: row;
      padding: 32px 24px;
    }

    #text-content {
      display: block;
      padding-left: 32px;
    }

    h1 {
      color: var(--web-kiosk-text-color, hotpink);
      font-size: 26px;
      font-weight: 700;
      line-height: 32px;
      margin: 0;
    }

    p {
      color: var(--web-kiosk-device-attribute-body-color, hotpink);
      font-size: 22px;
      line-height: 32px;
      font-weight: 400;
      margin: 0;
      padding-top: 8px;
    }
  `;
}
